import React from 'react';
import styled, { css } from 'styled-components';
import { Nav } from '@catalogo/core-nav';

const DepartmentList = ({ dispatchMetrics, trendingDepartments, mainUrl }) => (
  <DepartmentContainer>
    {trendingDepartments.map(department => (
      <DepartmentLabel key={department.id}>
        <DepartmentLink
          to={department.link}
          isSelected={mainUrl === department.link}
          onClick={() =>
            dispatchMetrics('event:track', {
              event: 'c:click',
              action: 'click',
              category: 'menu-tts',
              label: department.title,
            })
          }
        >
          {department.title}
        </DepartmentLink>
      </DepartmentLabel>
    ))}
  </DepartmentContainer>
);
const DepartmentContainer = styled.ul`
  color: ${({ theme }) => theme.grey.dark};
  font-size: ${({ theme }) => theme.fontSize.xs};
  width: 100%;
  padding: 0 35px;
  height: 40px;
  white-space: nowrap;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  margin: 0;
`;
const DepartmentLabel = styled.li`
  display: inline-block;
  line-height: 40px;
  position: relative;

  & + li {
    margin-left: 24px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 0;
    height: 100%;
    opacity: 0;
    background-color: ${({ theme }) => theme.grey.lighter};
    transition: all 0.2s;
    transform: translateX(-50%);
  }

  &:hover::before {
    width: calc(100% + 32px);
    opacity: 1;
  }
`;

const DepartmentLink = styled(Nav)`
  display: block;
  position: relative;
  z-index: 1;
  color: #333;

  &:hover,
  &:active {
    color: #333;
    text-decoration: none;
  }

  &::after {
    ${({ theme, isSelected }) =>
      isSelected &&
      css`
        content: '';
        position: absolute;
        bottom: 2px;
        left: 0;
        right: 0;
        height: 2px;
        border-radius: 16px;
        background: ${theme.primaryColor};
      `}
  }
`;

export default DepartmentList;
